module.exports = __webpack_public_path__ + "static/media/scale-icon.55ced2ca.svg";